<template>
    <div>
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-10">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Cari berdasarkan NOPOL"
                        aria-label="Search"
                        style="display: flex; font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                        @keyup.enter="fetchData"
                    >
                </div>
                <div 
                    class="col-md-2 text-right" 
                    style="display: flex; justify-content: flex-end">
                    <button
                        class="btn"
                        type="button"
                        style="
                            background-color: #1B698E; 
                            color: white; 
                            padding: 0 50px; 
                            height: 100%; 
                            font-weight: bold; 
                            display: flex; 
                            align-items: center; 
                            font: normal normal 600 14px/21px Poppins;"
                        @click="fetchData"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">
            <div class="mb-4 row align-items-center">
                <div class="col-md-4"></div>
                <div class="col-md-4 text-center">
                    <h3 class="tableTitle" style="font: normal normal normal 16px/25px Poppins;">Kelola Status</h3>
                </div>
                <div class="col-md-4">
                    <div class="d-flex justify-content-end align-items-center">
                        <span class="mr-2" style="font: normal normal normal 12px/18px Poppins; white-space: nowrap;">Filter tanggal</span>
                        <flat-pickr
                            :config="rangePickr"
                            placeholder="Pilih Tanggal"
                            v-model="selected.date"
                            class="form-control"
                            style="font: normal normal normal 12px/18px Poppins; background-color: #CFECF9; border: none; border-radius: 8px; width: 197px; height: 36px;"
                        ></flat-pickr>
                    </div>
                </div>
            </div>
            
            <!-- Custom Table -->
            <div class="table-responsive">
                <table class="table custom-table">
                    <thead>
                        <tr>
                            <th @click="sortBy('nopol')" class="sortable">
                                NOPOL
                                <span class="sort-icon">
                                    <i class="fas fa-sort" v-if="sortKey !== 'nopol'"></i>
                                    <i class="fas fa-sort-up" v-else-if="sortOrder === 'ASC'"></i>
                                    <i class="fas fa-sort-down" v-else></i>
                                </span>
                            </th>
                            <th>No PO</th>
                            <th>Tgl Ekspedisi</th>
                            <th>Ekspedisi</th>
                            <th>NAMA DRIVER</th>
                            <th>Tindakan Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in data" :key="index">
                            <td>{{ item.nopol }}</td>
                            <td>{{ item.no_po }}</td>
                            <td>{{ item.tgl_ekspedisi }}</td>
                            <td>{{ item.ekspedisi }}</td>
                            <td>{{ item.nama_driver }}</td>
                            <td>
                                <div class="status-dropdown">
                                    <div 
                                        class="status-display" 
                                        @click="toggleDropdown(index)"
                                    >
                                        <span>{{ item.status }}</span>
                                        <i 
                                            class="fas status-arrow"
                                            :class="openDropdown === index ? 'fa-chevron-up' : 'fa-chevron-down'"
                                        ></i>
                                    </div>
                                    
                                    <!-- Dropdown Menu -->
                                    <div 
                                        v-if="openDropdown === index" 
                                        class="dropdown-menu show"
                                    >
                                        <a 
                                            class="dropdown-item" 
                                            :class="{ 'active': item.status === 'Terkirim' }"
                                            href="javascript:void(0)"
                                            @click="updateStatus(item, 'Terkirim')"
                                        >
                                            Terkirim
                                        </a>
                                        <a 
                                            class="dropdown-item" 
                                            :class="{ 'active': item.status === 'Belum dikirim' }"
                                            href="javascript:void(0)"
                                            @click="updateStatus(item, 'Belum dikirim')"
                                        >
                                            Belum dikirim
                                        </a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="data.length === 0">
                            <td colspan="6" class="text-center py-4">Tidak ada data</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="pagination-container" v-if="pagination.total > 0">
                <div class="pagination-info">
                    Menampilkan {{ data.length }} dari {{ pagination.total }} data
                </div>
                <div class="pagination-buttons">
                    <button 
                        class="btn btn-sm btn-outline-secondary" 
                        :disabled="pagination.currentPage === 1"
                        @click="changePage(pagination.currentPage - 1)"
                    >
                        <i class="fas fa-chevron-left"></i>
                    </button>
                    <span class="page-info">Halaman {{ pagination.currentPage }} dari {{ pagination.totalPages }}</span>
                    <button 
                        class="btn btn-sm btn-outline-secondary" 
                        :disabled="pagination.currentPage === pagination.totalPages"
                        @click="changePage(pagination.currentPage + 1)"
                    >
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- Table End -->
    </div>
</template>

<script>
import moment from 'moment';
import debounce from 'debounce';

export default {
    metaInfo: {
        title: 'Kelola Status'
    },
    data() {
        // Default date range: 1st of last month until yesterday
        let startDate = moment().subtract(1, 'month').startOf('month').format("YYYY-MM-DD");
        let yesterday = moment().subtract(1, 'day').format("YYYY-MM-DD");

        return {
            rangePickr: {
                mode: 'range',
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d/m/Y",
                altInputClass: 'form-control filterInput'
            },
            selected: {
                date: `${startDate} to ${yesterday}`
            },
            filter: {
                search: '',
                start: startDate,
                end: yesterday
            },
            data: [],
            openDropdown: null,
            sortKey: 'tgl_ekspedisi',
            sortOrder: 'DESC',
            pagination: {
                currentPage: 1,
                totalPages: 1,
                total: 0,
                limit: 15
            },
            loading: false
        }
    },
    mounted() {
        this.fetchData();
        // Close dropdown when clicking outside
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    watch: {
        'selected.date'() {
            let split = this.selected.date.split(" to ");
            this.filter.start = split[0];
            this.filter.end = split.length > 1 ? split[1] : split[0];
            
            this.updateDebounceData();
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            try {
                const params = {
                    pagination: 'true',
                    page: this.pagination.currentPage,
                    limit: this.pagination.limit,
                    by: this.sortKey,
                    order: this.sortOrder,
                    start: this.filter.start,
                    end: this.filter.end
                };

                if (this.filter.search) {
                    params.search = this.filter.search;
                }

                const response = await this.$http.get('/api/monitoring/kelola-status', { params });
                
                if (response.data && response.data.data) {
                    this.data = response.data.data;
                    if (response.data.meta) {
                        this.pagination.currentPage = response.data.meta.currentPage || 1;
                        this.pagination.total = response.data.meta.total || 0;
                        this.pagination.totalPages = Math.ceil(this.pagination.total / this.pagination.limit);
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: 'Gagal mengambil data'
                });
            } finally {
                this.loading = false;
            }
        },
        toggleDropdown(index) {
            if (this.openDropdown === index) {
                this.openDropdown = null;
            } else {
                this.openDropdown = index;
            }
        },
        handleClickOutside(event) {
            if (!event.target.closest('.status-dropdown')) {
                this.openDropdown = null;
            }
        },
        async updateStatus(item, newStatus) {
            // Only update if status is different and new status is 'Terkirim'
            // Note: API only supports updating to 'Terkirim' (status_pengiriman = 4)
            if (item.status === newStatus) {
                this.openDropdown = null;
                return;
            }

            if (newStatus === 'Belum dikirim') {
                this.$swal({
                    icon: 'info',
                    title: 'Info',
                    text: 'Status sudah dalam kondisi Belum dikirim'
                });
                this.openDropdown = null;
                return;
            }

            // Confirm before updating
            const result = await this.$swal({
                title: 'Konfirmasi',
                text: `Apakah Anda yakin ingin mengubah status menjadi "${newStatus}"?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1B698E',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya, Ubah',
                cancelButtonText: 'Batal'
            });

            if (result.isConfirmed) {
                try {
                    const payload = {
                        nopol: item.nopol,
                        no_po: item.no_po
                    };

                    const response = await this.$http.put('/api/monitoring/kelola-status', payload);

                    if (response.data) {
                        this.$swal({
                            icon: 'success',
                            title: 'Berhasil',
                            text: response.data.message || 'Status berhasil diupdate'
                        });
                        
                        // Refresh data
                        this.fetchData();
                    }
                } catch (error) {
                    console.error('Error updating status:', error);
                    this.$swal({
                        icon: 'error',
                        title: 'Error',
                        text: (error.response && error.response.data && error.response.data.message) || 'Gagal mengupdate status'
                    });
                }
            }

            this.openDropdown = null;
        },
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
            } else {
                this.sortKey = key;
                this.sortOrder = 'ASC';
            }
            this.fetchData();
        },
        changePage(page) {
            if (page < 1 || page > this.pagination.totalPages) return;
            this.pagination.currentPage = page;
            this.fetchData();
        },
        updateDebounceData: debounce(function () {
            this.fetchData();
        }, 1500)
    }
}
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000F;
    padding: 20px;
}

.tableTitle {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #343434;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
    font: normal normal normal 12px/18px Poppins;
}

.custom-table thead th {
    color: #343434;
    font-weight: 500;
    padding: 12px 16px;
    border-bottom: 1px solid #EFEFEF;
    white-space: nowrap;
}

.custom-table tbody td {
    padding: 16px;
    color: #343434;
    border-bottom: 1px solid #F5F5F5;
    vertical-align: middle;
}

.sortable {
    cursor: pointer;
    user-select: none;
}

.sort-icon {
    margin-left: 4px;
    color: #999;
}

.status-dropdown {
    position: relative;
    display: inline-block;
}

.status-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s;
    min-width: 120px;
}

.status-display:hover {
    background-color: #F5F5F5;
}

.status-arrow {
    font-size: 12px;
    color: #666;
    transition: transform 0.2s;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    min-width: 140px;
    padding: 4px 0;
    margin-top: 4px;
    background-color: #fff;
    border: 1px solid #E5E5E5;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dropdown-item {
    display: block;
    padding: 8px 16px;
    color: #343434;
    text-decoration: none;
    font-size: 12px;
    transition: background-color 0.2s;
}

.dropdown-item:hover {
    background-color: #F5F5F5;
}

.dropdown-item.active {
    background-color: #F36F21;
    color: white;
}

.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #EFEFEF;
}

.pagination-info {
    font-size: 12px;
    color: #666;
}

.pagination-buttons {
    display: flex;
    align-items: center;
    gap: 12px;
}

.page-info {
    font-size: 12px;
    color: #666;
}

.filterInput {
    border: 1px solid #D5D5D5;
    border-radius: 8px;
    padding: 10px 16px;
}

.filterInput:focus {
    outline: none;
    border-color: #1B698E;
    box-shadow: 0 0 0 2px rgba(27, 105, 142, 0.1);
}
</style>
